import { UserRuleType, UserType } from 'types';

import { SetPortIdReturn, SetUserReturn } from '../actions/userActions';

export interface UserState {
    user: UserType;
    portId: number;
    rules: UserRuleType[];
    language?: string;
}

const initialState: UserState = {
    user: JSON.parse(localStorage.getItem('user') || '{}'),
    portId: 0,
    rules: [],
};

type UserActions = SetUserReturn | SetPortIdReturn;
// Define the reducer
export const userReducer = (state: UserState = initialState, action: UserActions): UserState => {
    switch (action.type) {
        case 'SET_USER':
            // @ts-ignore
            return { ...state, user: { ...state.user, ...action.payload } };
        case 'SET_PORT_ID':
            return {
                ...state,
                // @ts-ignore
                portId: action.payload,
                rules: state.user.user_rules.filter((x) => {
                    return x.port_id === action.payload;
                }),
            };

        default:
            return state;
    }
};
